<div
  id="overlay"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
  (click)="onOverlayClick($event)"
>
  <div class="bg-white rounded-lg shadow-lg relative w-[80%] max-w-4xl h-[85vh] overflow-hidden mx-4">
    <div class="flex flex-col h-full">
      <div class="flex justify-between items-center border-b px-4 py-4">
        <h2 class="text-xl font-bold text-gray-800">Scope Information</h2>
        <button class="stroke-[#757575] cursor-pointer hover:stroke-blue-700 hover:bg-gray-200 p-2" (click)="onClose()">
          <ui-icon name="close" class="stroke-black" size="size-4"></ui-icon>
        </button>
      </div>

      <div class="flex border-b p-4 pb-0">
        <button
        class="flex-1 py-2 text-center text-gray-600 hover:text-blue-500"
        [ngClass]="{ 'border-b-2 border-blue-500 text-blue-500': activeTab === 'OVERVIEW' }"
        (click)="setActiveTab('OVERVIEW')"
        >
        Overview
        </button>
        <button
        class="flex-1 py-2 text-center text-gray-600 hover:text-blue-500"
        [ngClass]="{ 'border-b-2 border-blue-500 text-blue-500': activeTab === 'DICTIONARY' }"
        (click)="setActiveTab('DICTIONARY')"
      >
        Dictionary
      </button>
        <button
        class="flex-1 py-2 text-center text-gray-600 hover:text-blue-500"
        [ngClass]="{ 'border-b-2 border-blue-500 text-blue-500': activeTab === 'DETAILS' }"
        (click)="setActiveTab('DETAILS')"
      >
        Details
      </button>


      </div>

      <div class="flex-1 overflow-y-auto px-4 py-4">
        <ng-container *ngIf="activeTab === 'DICTIONARY'">
          <div #scopeOverView
            class=" bg-white rounded-[8px] p-4">
            <div *ngIf="
              selectedTables.length > 0 || isScopeDetailsLoading;
              else noTables
            " class="overflow-y-auto">
              <div>
                <table class="text-sm w-full">
                  <thead>
                    <tr class="bg-white uppercase border-b">
                      <th class="font-bold text-left py-3 pl-4">
                        Object Hierarchy
                      </th>
                      <!-- <th class="font-bold text-left py-3 px-2">Display Name</th> -->
                      <th class="font-bold text-left py-3 px-2">Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if(isScopeDetailsLoading){
                    <tr class="pl-8">
                      <td colspan="4">
                        <skeleton-app-flat-hierarchy [contentWidth]="'w-full pl-4'" />
                      </td>
                    </tr>
                    }@else{
                    <ng-container *ngFor="let table of selectedTables">
                      <tr class="border-b">
                        <td class="py-4 pl-4 flex items-center">
                          <img *ngIf="table.expanded" src="assets/icons/chevron-down.svg" alt=""
                            class="mr-3 p-2 cursor-pointer rounded-full hover:bg-gray-200"
                            (click)="toggleTable(table)" />
                          <img *ngIf="!table.expanded" src="assets/icons/chevron-right.svg" alt=""
                            class="mr-3 p-2 cursor-pointer rounded-full hover:bg-gray-200"
                            (click)="toggleTable(table)" />
                          <ui-icon name="table-icon" size="size-4" class="stroke-[#2e3137] mr-4"></ui-icon>
                          <span class="text-[#5D5D5D]">{{
                            table.name
                            }}</span>
                        </td>
                        <td class="py-4 px-2">
                          <span class="text-[#5D5D5D]">{{ "" }}
                          </span>
                        </td>
                      </tr>
                      @if(table.loading){
                      <tr class="pl-8">
                        <td colspan="4">
                          <skeleton-app-flat-hierarchy [contentWidth]="'w-full pl-16'" />
                        </td>
                      </tr>
                      }@else{
                        <ng-container *ngIf="table.expanded">
                          <tr *ngFor="let column of table.columns" class="border-b">
                            <td class="py-4 pl-16 flex items-center">
                              <ui-icon name="column" size="size-4" class="stroke-[#667085] mr-4"></ui-icon>
                              <img
                                src="assets/icons/{{ column.parameters?.TYPE }}.svg"
                                alt="{{ column.parameters?.TYPE }}"
                                title="{{ column.parameters?.TYPE }}"
                                class="mr-1"
                              />
                              <span class="text-black text-sm font-calibri">
                                {{ column.name }} 
                              </span>
                            </td>
                            <!-- <td class="py-4 px-2">
                              <span class="text-black text-sm font-calibri">
                                {{ column.parameters?.DISPLAY_NAME }}
                              </span>
                            </td> -->
                            <td class="py-4 px-2">
                              <span class="text-black text-sm font-calibri">
                                {{ column.description }}
                              </span>
                            </td>
                          </tr>
                        </ng-container>
                      }
                    </ng-container>
                    }
                  </tbody>
                </table>
              </div>
            </div>
            <ng-template #noTables>
              <div class="flex justify-center items-center my-44">
                <div class="items-center flex flex-col">
                  <img src="assets/img/scope-data.png" alt="" class="h-44 w-44" />
                  <p class="w-[250px] text-center text-[#475467]">
                    Select a table on the left to begin scoping it.
                  </p>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <ng-container *ngIf="activeTab === 'DETAILS'">
          @if(isScopeDetailsLoading){
            <div class="flex justify-center items-center h-full">
              <app-loader [loadingText]="'Loading Scope Details'"></app-loader>
            </div>
          } @else {
          <div class="px-4 py-4 space-y-4">
            <!-- Connection Details Collapsible -->
            <div class="rounded-md">
              <!-- Header -->
              <div 
                class="flex items-center justify-between p-3 cursor-pointer border-b select-none"
                (click)="toggleConnectionDetails()"
              >
                <span class="text-base font-semibold text-gray-800">Details</span>
                <ui-icon 
                  name="chevron-down" 
                  class="stroke-gray-600 stroke-1 transform transition-transform duration-200"
                  [ngClass]="{'rotate-180': detailsExpanded}" />
              </div>
              <!-- Content -->
              <div *ngIf="detailsExpanded" class="p-4">
                <p class="text-gray-600 text-sm mb-2">
                  <span class="font-semibold">Data Scope Name: </span>
                  <a [href]="'dashboard/data-scopes/single?id=' + this.selectedScopeId" class="hover:underline text-blue-600 hover:text-blue-800" target="_blank">
                    {{ datascopeName }}
                  </a>
                </p>
                <p class="text-gray-600 text-sm mb-2">
                  <span class="font-semibold">Data Scope Description: </span>{{ datascopeDescription }}
                </p>
                <p class="text-gray-600 text-sm mb-2">
                  <span class="font-semibold">Connection Name: </span>
                  <a [href]="'dashboard/connections/single?id=' + this.connectionId" class="hover:underline text-blue-600 hover:text-blue-800" target="_blank">
                    {{ connectionName }}
                  </a>
                </p>
                <p class="text-gray-600 text-sm mb-2">
                  <span class="font-semibold">Datasource: </span>{{ dataSourceName }}
                </p>
                <p class="text-gray-600 text-sm mb-2">
                  <span class="font-semibold">Connection Description: </span>{{ connectionDescription }}
                </p>
                <p class="text-gray-600 text-sm mb-2">
                  <span class="font-semibold">Created At: </span>{{ connectionCreatedDate | date:'MM-dd-yyyy' }}
                </p>
                <p class="text-gray-600 text-sm">
                  <span class="font-semibold">Updated At: </span>{{ connectionUpdatedDate | date:'MM-dd-yyyy' }}
                </p>
              </div>
            </div>
        
            <!-- Join Rules Collapsible -->
            <div class="rounded-md">
              <!-- Header -->
              <div 
                class="flex items-center justify-between p-3 cursor-pointer border-b select-none"
                (click)="toggleJoinRules()"
              >
                <span class="text-base font-semibold text-gray-800">Join Rules</span>
                <ui-icon 
                  name="chevron-down" 
                  class="stroke-gray-600 stroke-1 transform transition-transform duration-200"
                  [ngClass]="{'rotate-180': joinRulesExpanded}" />
              </div>
              <!-- Content -->
              <div *ngIf="joinRulesExpanded" class="p-4">
                <ul>
                  <li *ngFor="let join of joinSecurity; let i = index" class="mb-2">
                    <div class="p-4 bg-white rounded-lg shadow border border-gray-200">
                      <span class="text-sm text-gray-700">{{ join.LEFT_TABLE_COLUMN_FQPN }}</span>
                      <span class="text-sm text-gray-700 mx-1"> = </span>
                      <span class="text-sm text-gray-700">{{ join.RIGHT_TABLE_COLUMN_FQPN }}</span>
                      <span class="text-sm font-semibold text-gray-700 ml-1">
                        ({{ join.JOIN_TYPE | uppercase }})
                      </span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          }
        </ng-container>
        
        
        <ng-container *ngIf="activeTab === 'OVERVIEW'">
          @if(isOverViewLoading) {
            <!-- still show spinner while loading -->
            <div class="flex justify-center items-center h-full">
              <app-loader [loadingText]="'Loading Scope Overview'"></app-loader>
            </div>
        
          } @else if(overviewError) {
            <!-- toast-style error banner -->
            <div
              class="flex items-start justify-between my-4 p-4 border border-[#FDA29B] rounded-lg bg-[#FFFBFA]"
              style="transition: opacity 0.3s ease; opacity: 1;"
            >
              <img src="assets/icons/alert.svg" alt="Error Icon" />
              <div class="mx-4 text-[#B42318]">
                <p class="font-medium leading-none mb-2">Overview generation failed</p>
                <p class="text-sm">{{ overviewError }}</p>
              </div>
              <div (click)="overviewError = null" class="cursor-pointer p-1">
                <img src="assets/icons/close.svg" alt="Close Icon" />
              </div>
            </div>
        
          } @else {
            <!-- finally, show the actual overview -->
            <div class="text-gray-600">
              <div class="py-2 px-4 rounded-lgbg-[#F5F5F5] text-black text-[13px]">
                <markdown [data]="overviewData" class="prose prose-slate"></markdown>
              </div>
            </div>
          }
        </ng-container>        
      </div>
    </div>
  </div>
</div>
